import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import HRProcessFlow from "./HRProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  HR_DOMAIN_INTRO,
  HR_GROUPS,
  HR_USE_CASES_SEO,
  HR_DOMAIN_FAQS,
  HR_ITEM_LIST_JSONLD,
  HR_BREADCRUMB_JSONLD,
  HR_WEBPAGE_JSONLD,
  HR_FAQ_JSONLD,
} from "../../data/hrUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<HRProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = HR_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;

  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function HRDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");

  const visibleGroups =
    activeFilter === "all"
      ? HR_GROUPS
      : HR_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={HR_DOMAIN_INTRO}
        domainSlug="hr-domain"
        useCaseCount={HR_USE_CASES_SEO.length}
        groupCount={HR_GROUPS.length}
        itemListJsonLd={HR_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={HR_BREADCRUMB_JSONLD}
        faqJsonLd={HR_FAQ_JSONLD}
        webPageJsonLd={HR_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>

      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{HR_DOMAIN_INTRO.title}</h1>
          {HR_DOMAIN_INTRO.content ? (
            <p>{HR_DOMAIN_INTRO.content}</p>
          ) : null}
        </div>
      </header>

      <UseCaseIndexGrid
        useCases={HR_USE_CASES_SEO}
        groups={HR_GROUPS}
        heading="HR Domain Use Cases"
        onFilterChange={setActiveFilter}
      />

      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={HR_DOMAIN_INTRO.title}
        domainFaqs={HR_DOMAIN_FAQS}
        useCases={HR_USE_CASES_SEO}
      />
    </div>
  );
}

